import { redirectToLogin } from "@/common/api/core/request";
import { ADMIN_TYPE, CUSTOMER_TYPE } from "@/common/constant";
import AdminUser from "@/model/adminUser";
import CustomerUser from "@/model/customerUser";
import User from "@/model/user";
import store from "@/store";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";

@Module({ namespaced: true })
export default class AuthModule extends VuexModule {
  public token = localStorage.getItem("token") || "";
  public refresh_token = localStorage.getItem("refresh-token") || "";
  public authenticate_status = "";
  public expired_at = "";
  public user_type = "";
  public isOpen = false;
  public userLogging: User;
  public admin_user: AdminUser = null;
  public customer_user: CustomerUser = null;
  public is_login_time = false;
  public permissions = null;
  public role = null;

  @Mutation
  public setAuthenticateStatus(status: string): void {
    this.authenticate_status = status;
  }
  @Mutation
  public setToken(token: string): void {
    this.token = token;
  }

  @Mutation
  public setRefreshToken(refreshToken: string): void {
    this.refresh_token = refreshToken;
  }

  @Mutation
  public setExpiredAt(time: string): void {
    this.expired_at = time;
  }
  @Mutation
  public setUserType(userType: string): void {
    this.user_type = userType;
  }
  @Mutation
  public setUserLogging(user: any): void {
    this.admin_user = new AdminUser(user);
  }
  @Mutation
  public setAdminUser(user: AdminUser): void {
    this.admin_user = user ? new AdminUser(user) : null;
  }

  @Mutation
  public setCustomerUser(user: CustomerUser): void {
    this.customer_user = user ? new CustomerUser(user) : null;
  }
  @Mutation
  public setIsOpen(status: boolean): void {
    this.isOpen = status;
  }

  @Mutation
  public setIsLoginTime(isLoginTime: boolean): void {
    this.is_login_time = isLoginTime;
  }

  @Mutation
  public setRole(role: string): void {
    this.role = role;
  }

  @Mutation
  public setPermissions(permissions: any): void {
    this.permissions = permissions;
  }

  @Action({ rawError: true })
  public updateAuthenticateStatus(status: string): void {
    this.context.commit("setAuthenticateStatus", status);
  }
  @Action
  public updateExpiredAt(time: string): void {
    this.context.commit("setExpiredAt", time);
  }
  @Action
  public updateUserType(userType: string): void {
    this.context.commit("setUserType", userType);
  }

  @Action
  public async fetchCurrentUser(user: any): Promise<void> {
    this.context.commit("setUserLogging", user);
    this.context.commit("setPermissions", user.permissions);
    this.context.commit("setRole", user.role);
  }
  @Action({ rawError: true })
  public updateToken(token: string): void {
    this.context.commit("setToken", token);
  }

  @Action({ rawError: true })
  public updateRefreshToken(token: string): void {
    this.context.commit("setRefreshToken", token);
  }

  @Action
  public updateIsOpen(status: boolean): void {
    this.context.commit("setIsOpen", status);
  }

  @Action
  public updateIsLoginTime(isLoginTime: boolean): void {
    this.context.commit("setIsLoginTime", isLoginTime);
  }

  @Action
  public logout(): void {
    this.context.commit("setToken", "");
    this.context.commit("setAdminUser", null);
    store.dispatch("Router/setSearchParameters", null);
    redirectToLogin();
  }

  get getAuthenticateStatus(): string {
    return this.authenticate_status;
  }
  get getExpiredAt(): string {
    return this.expired_at;
  }
  get getUserType(): string {
    return this.user_type;
  }

  get getUserLogging(): any {
    return this.admin_user;
  }

  get getAdminUser(): AdminUser {
    return this.admin_user;
  }
  get getCustomerUser(): CustomerUser {
    return this.customer_user;
  }
  get getToken(): string {
    return this.token;
  }

  get loggingName(): string {
    if (this.user_type == ADMIN_TYPE) {
      return this.admin_user.administrator_name;
    }
    // else if (this.customer_user.m_cart_customer) {
    //   return `${this.customer_user.m_cart_customer.customer_name}　${this.customer_user.account_supervisor_name}`;
    // }
  }

  get isCustomer(): boolean {
    return this.user_type == CUSTOMER_TYPE;
  }

  get getIsOpen(): boolean {
    return this.isOpen;
  }

  get isLoginTime(): boolean {
    return this.is_login_time;
  }
}

// export default getModule(AuthModule);
